<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>
       <button ref="completeButtonRef" @click="completeOrder"></button>
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <span ref="focoFake" tabindex="0" class="sr-only">Foco</span>
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Edição de Dados</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  <!-- Empresa Mãe -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Empresa Mãe (Opcional)</label>
                      <input
                        v-model="empresaMaeBusca"
                        @input="buscarEmpresasMae"
                        type="text"
                        placeholder="Digite o nome para buscar..."
                        class="mt-2 block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                      <ul
                        v-if="sugestoesEmpresasMae.length"
                        class="mt-1 border border-gray-300 rounded-md bg-white shadow-lg p-2 max-h-40 overflow-y-auto"
                      >
                        <li
                          v-for="(empresa, index) in sugestoesEmpresasMae"
                          :key="index"
                          @click="vincularEmpresaMae(empresa)"
                          class="cursor-pointer hover:bg-gray-100 p-2 rounded text-sm text-gray-700"
                        >
                          {{ empresa.nome }}
                        </li>
                      </ul>
                      <div v-if="data.empresa_mae_nome" class="mt-2 text-sm font-semibold text-green-700">
                        Selecionada: {{ data.empresa_mae_nome }}
                        <button type="button" @click="removerEmpresaMae" class="ml-2 text-red-500 hover:text-red-700 text-xs">Remover</button>
                      </div>
                  </div>

                  <div v-for="(input, index) in inputsList" :key="index" class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label :for="input.name" class="block text-sm font-medium leading-6 text-gray-900">{{ input.label }}</label>
                    <input
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :type="input.type"
                      :required="false"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      :placeholder="placeHolderValues[input.name]"
                      :value="data[input.name]"
                    />
                  </div>
                  <!-- Botão de confirmar -->
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-customPurple px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-sienaBlue">Confirmar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import debounce from 'lodash/debounce';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';

  export default {
    name: 'EmpresasEditingForm',
    created(){
        this.buscarEmpresasMae = debounce((...args) => {
          this._buscarEmpresasMae(...args);
        }, 400);
    },
    props: {
      inputsList: {
        type: Array,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      placeHolderValues: {
        type: Object,
        required: true
      }
    },  
    watch: {
      placeHolderValues: {
        handler(newValue) {
          if (newValue && Object.keys(newValue).length > 0) {
            this.data = Object.assign({}, newValue);
            this.empresaMaeBusca = this.data.empresa_mae_nome || '';
          }
        },
        deep: true,
        immediate: true
      }
    },
    data() {
      return {
        data:{},
        novoPlano: {
          nome: '',
          descricao: '',
          valor: null,
          regra_de_faturamento: ''
        },
        focoFake: null,
        empresaMaeBusca: '',
        sugestoesEmpresasMae: [],
        onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
      };
    },
    methods: {
      async _buscarEmpresasMae() {
        if (!this.empresaMaeBusca || this.empresaMaeBusca.length < 3) {
          this.sugestoesEmpresasMae = [];
          return;
        }
        this.getEmpresasMae(this.empresaMaeBusca);
      },
      async getEmpresasMae(query) {
        const empresasRepo = new EmpresasRepository();
        try {
          const response = await empresasRepo.getEmpresaQuery(this.onlineUser.token, query);
          if (response?.status === 200) {
            this.sugestoesEmpresasMae = response.data;
          }
        } catch (error) {
          handleUnauthorized(error);
        }
      },
      vincularEmpresaMae(empresa){
        this.data.empresa_mae_id = empresa.id;
        this.data.empresa_mae_nome = empresa.nome;
        this.empresaMaeBusca = '';
        this.sugestoesEmpresasMae = [];
      },
      removerEmpresaMae() {
        this.data.empresa_mae_id = null;
        this.data.empresa_mae_nome = '';
      },
      sendData(e) {
        e.preventDefault();
        this.$emit('editing-data', this.data,this.placeHolderValues.id);
      },
      closeDialog() {
        this.$emit('update-open', false);
      },
      deletarPlano(id){
        this.$emit('deletar-plano',id);
      },
      formatDate(dateString) {
        if (!dateString) return '';
        
        // Verifica se o valor contém data e hora, separa apenas a data (YYYY-MM-DD)
        if (typeof dateString === 'string' && dateString.includes(' ')) {
          return dateString.split(' ')[0]; // Retorna apenas a parte da data
        }
        
        return dateString; // Retorna o valor original se já estiver no formato correto
      },
      emitirNovoPlano() {
        if (!this.novoPlano.nome || !this.novoPlano.valor || !this.novoPlano.regra_de_faturamento) {
          alert('Preencha todos os campos do plano.');
          return;
        }

        const planoCompleto = {
          ...this.novoPlano,
          empresa_id: this.placeHolderValues.id
        };

        this.$emit('add-plano', planoCompleto);

        this.novoPlano = {
          nome: '',
          descricao: '',
          valor: null,
          regra_de_faturamento: ''
        };
      }
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
    },
  }
</script>